import React, { PropsWithChildren } from 'react';
import { Box, BoxProps } from 'grommet';

export const RowBox: React.FC<RowBoxProps> = ({ children, ...boxProps }) => {
  return (
    <Box direction="row" {...boxProps}>
      {children}
    </Box>
  );
};

export type RowBoxProps = PropsWithChildren & BoxProps;
